module.exports = __webpack_public_path__ + "img/1580004249.562429aa.jpg";